import {
  Directive,
  HostBinding,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Subscription } from 'rxjs';

import {
  DEFAULT_LOADER_STATE_KEY,
  LoaderService,
} from '~/core/services/loader/loader.service';

/**
 * Loading directive:
 * Triggers `disabled` state on component when loaderService is used
 * This can be used on any component that has a disabled state (buttons, inputs, etc.)
 */
@Directive({
  selector:
    'button[loading], input[loading], select[loading], option[loading], textarea[loading], fieldset[loading], optgroup[loading]',
})
export class LoadingDirective implements OnInit, OnDestroy {
  @Input() public loaderKey = DEFAULT_LOADER_STATE_KEY;
  private readonly subscription = new Subscription();
  private isLoading = false;

  constructor(private readonly loaderService: LoaderService) {}

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public ngOnInit(): void {
    this.subscription.add(
      this.loaderService.loading$.subscribe((loader) => {
        // use only configured loader key
        if (loader.key !== this.loaderKey) {
          return;
        }
        this.isLoading = loader.state.loading;
      })
    );
  }

  @Input()
  @HostBinding('disabled')
  public get loaderState(): boolean {
    return this.isLoading;
  }
}
